/* Calibre — estabilidad del regalo automático.
   Evita reemplazar <theme-drawer> mientras su dialog está abierto.
   La lógica antigua de calibre.js se neutraliza tomando el atributo
   data-cal-regalo y esta capa actualiza únicamente .cart-drawer__inner. */
(function () {
  'use strict';

  if (window.__calibreGiftStability) return;
  window.__calibreGiftStability = true;

  var LEGACY = '[data-cal-regalo]';
  var SAFE = '[data-cal-regalo-seguro]';
  var RETARDO = 80;
  var PAUSA_ERROR = 15000;

  var trabajando = false;
  var intentado = '';
  var pausaHasta = 0;
  var reloj = null;
  var pendientes = 0;
  var versionCarrito = 0;
  var desfasado = false;
  var descarte = '';
  var claveDescarte = 'calibre:regalo-descartado';

  try { descarte = window.sessionStorage.getItem(claveDescarte) || ''; } catch (e) {}

  function recordarDescarte(variante) {
    descarte = variante || '';
    try {
      if (descarte) window.sessionStorage.setItem(claveDescarte, descarte);
      else window.sessionStorage.removeItem(claveDescarte);
    } catch (e) {}
  }

  function ruta(archivo) {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + archivo;
  }

  function mostrarDescarte(b) {
    var mensaje = b.querySelector('.cal-regalo-progreso__message');
    if (mensaje && b.dataset.dismissedMessage && mensaje.textContent !== b.dataset.dismissedMessage) {
      mensaje.textContent = b.dataset.dismissedMessage;
    }
  }

  function observarCambio(evento) {
    if (!evento.promise) return;
    var b = bloque();
    var variante = b && b.dataset.variante;
    var clavesRegalo = Array.prototype.map.call(document.querySelectorAll('[data-cal-gift][data-key]'), function (fila) {
      return fila.dataset.key;
    });
    var regaloQuitado = evento.lines && evento.lines.find(function (linea) {
      return (evento.action === 'remove' || linea.quantity === 0) && clavesRegalo.indexOf(linea.id) !== -1;
    });
    if (!variante && regaloQuitado) variante = regaloQuitado.id.split(':')[0];
    pendientes += 1;
    versionCarrito += 1;
    if (trabajando) desfasado = true;
    clearTimeout(reloj);
    evento.promise.then(function (resultado) {
      if (regaloQuitado && variante) recordarDescarte(variante);
      if (resultado && resultado.detail && resultado.detail.items && !resultado.detail.items.length) recordarDescarte('');
    }, function () {}).then(function () {
      pendientes -= 1;
      programar();
    });
  }

  document.addEventListener('shopify:cart:lines-update', observarCambio, true);
  document.addEventListener('shopify:cart:discount-update', observarCambio, true);

  function raizCarrito() {
    return document.getElementById('shopify-section-cart-drawer-section');
  }

  /* Toma el control del bloque antes de que la versión antigua lo procese. */
  function tomar(root) {
    root = root || raizCarrito();
    if (!root) return;

    var nodos = [];
    if (root.matches && root.matches(LEGACY)) nodos.push(root);
    if (root.querySelectorAll) {
      nodos = nodos.concat(Array.prototype.slice.call(root.querySelectorAll(LEGACY)));
    }

    nodos.forEach(function (nodo) {
      nodo.setAttribute('data-cal-regalo-seguro', '');
      nodo.removeAttribute('data-cal-regalo');
    });
  }

  function bloque() {
    return document.querySelector(SAFE);
  }

  function programar() {
    tomar();
    clearTimeout(reloj);
    reloj = setTimeout(revisar, RETARDO);
  }

  function revisar() {
    if (trabajando || pendientes || Date.now() < pausaHasta) return;

    if (desfasado) {
      desfasado = false;
      trabajando = true;
      pedir(ruta('cart/update.js'), { updates: {} }).then(pintar).catch(fallo);
      return;
    }

    var b = bloque();
    if (!b) {
      if (!document.querySelector('[data-key]')) recordarDescarte('');
      return;
    }

    var umbral = parseInt(b.dataset.umbral, 10);
    var base = parseInt(b.dataset.base, 10);
    var variante = b.dataset.variante;
    var puesto = b.dataset.puesto === '1';
    if (!umbral || !variante || isNaN(base)) return;

    if (base < umbral) recordarDescarte('');
    if (base >= umbral && !puesto && descarte === variante) {
      mostrarDescarte(b);
      return;
    }

    var cantidadRegalos = 0;
    document.querySelectorAll('#shopify-section-cart-drawer-section [data-cal-gift][data-key]').forEach(function (fila) {
      if (fila.dataset.key.split(':')[0] !== variante) return;
      var cantidad = fila.querySelector('input[name="updates[]"]');
      cantidadRegalos += cantidad ? (parseInt(cantidad.value, 10) || 1) : 1;
    });
    if (base >= umbral && puesto && cantidadRegalos > 1) {
      poner(variante, umbral);
      return;
    }

    var agregar = base >= umbral && !puesto;
    var quitar = base < umbral && puesto;

    if (!agregar && !quitar) {
      intentado = '';
      return;
    }

    var firma = base + '|' + (puesto ? 1 : 0);
    if (firma === intentado) return;
    intentado = firma;

    if (agregar) poner(variante, umbral);
    else sacar();
  }

  function cuerpo(extra) {
    var datos = {
      sections: 'cart-drawer-section',
      sections_url: window.location.pathname
    };
    for (var k in extra) datos[k] = extra[k];
    return JSON.stringify(datos);
  }

  function pedir(url, datos) {
    var version = versionCarrito;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: cuerpo(datos)
    }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    }).then(function (datosCarrito) {
      if (version !== versionCarrito) {
        desfasado = true;
        return null;
      }
      return datosCarrito;
    });
  }

  function leerActual() {
    var version = versionCarrito;
    return fetch(ruta('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (carrito) {
        if (version !== versionCarrito || pendientes) {
          desfasado = true;
          return null;
        }
        return carrito;
      });
  }

  function regalosActuales(carrito, variante) {
    return carrito.items.filter(function (item) {
      return item.properties && item.properties._regalo && String(item.variant_id || item.id) === variante;
    });
  }

  function conservarUnRegalo(carrito, variante) {
    if (!carrito) return Promise.resolve(null);
    if (pendientes || desfasado) {
      desfasado = true;
      return Promise.resolve(null);
    }

    var regalos = regalosActuales(carrito, variante).sort(function (a, b) {
      return a.final_line_price / a.quantity - b.final_line_price / b.quantity;
    });
    var conservar = regalos[0];
    var cambiar = conservar && conservar.quantity > 1 ? conservar : regalos[1];
    if (cambiar) {
      return pedir(ruta('cart/change.js'), {
        id: cambiar.key,
        quantity: cambiar === conservar ? 1 : 0
      }).then(function (actualizado) { return conservarUnRegalo(actualizado, variante); });
    }

    if (carrito.sections) return Promise.resolve(carrito);
    return pedir(ruta('cart/update.js'), { updates: {} });
  }

  function poner(variante, umbral) {
    trabajando = true;
    leerActual().then(function (carrito) {
      if (!carrito) return null;

      var base = carrito.items.reduce(function (total, item) {
        return item.properties && item.properties._regalo ? total : total + item.original_line_price;
      }, 0);
      if (base < umbral || descarte === variante) {
        return pedir(ruta('cart/update.js'), { updates: {} });
      }
      if (regalosActuales(carrito, variante).length) return conservarUnRegalo(carrito, variante);

      return pedir(ruta('cart/add.js'), {
        items: [{
          id: Number(variante),
          quantity: 1,
          properties: { _regalo: '1' }
        }]
      });
    }).then(pintar).catch(fallo);
  }

  function sacar() {
    trabajando = true;

    fetch(ruta('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (c) {
        var linea = '';
        for (var i = 0; i < c.items.length; i += 1) {
          if (c.items[i].properties && c.items[i].properties._regalo) {
            linea = c.items[i].key;
            break;
          }
        }

        if (!linea) {
          trabajando = false;
          intentado = '';
          return;
        }

        if (pendientes || desfasado) {
          trabajando = false;
          desfasado = true;
          programar();
          return;
        }
        return pedir(ruta('cart/change.js'), { id: linea, quantity: 0 }).then(pintar);
      })
      .catch(fallo);
  }

  function actualizarContador(contenedor) {
    if (!contenedor) return;
    var badge = contenedor.querySelector('[ref="cartItemCount"]') || contenedor.querySelector('.theme-drawer__badge');
    if (!badge) return;

    var n = parseInt((badge.textContent || '').trim(), 10);
    if (isNaN(n)) return;

    document.querySelectorAll('.theme-drawer__badge, [data-cart-count], [ref="cartBubbleCount"]').forEach(function (el) {
      if (el.childElementCount) return;
      var esBurbuja = el.getAttribute('ref') === 'cartBubbleCount';
      el.textContent = esBurbuja && n >= 100 ? '' : String(n);
      if (esBurbuja) el.classList.toggle('hidden', n === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', n === 0);
      el.toggleAttribute('data-maintain-ratio', n <= 99);
    });
    document.querySelectorAll('cart-icon').forEach(function (el) {
      el.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    });
    try {
      window.sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
    } catch (e) {}
  }

  /* Punto clave del arreglo: NO se reemplaza el theme-drawer ni el dialog.
     Así el modal, el backdrop, el scroll-lock y el foco siguen vivos. */
  function pintar(d) {
    var html = d && d.sections ? d.sections['cart-drawer-section'] : null;
    if (!html) {
      trabajando = false;
      intentado = '';
      if (desfasado) programar();
      return;
    }

    var tmp = document.createElement('div');
    tmp.innerHTML = html;

    var nuevoInner = tmp.querySelector('.cart-drawer__inner');
    var actualInner = document.querySelector('#shopify-section-cart-drawer-section .cart-drawer__inner');

    if (!nuevoInner || !actualInner) {
      trabajando = false;
      intentado = '';
      return;
    }

    var listaActual = actualInner.querySelector('.cart-drawer__items');
    var scrollAnterior = listaActual ? listaActual.scrollTop : 0;

    /* El HTML que viene del servidor trae de nuevo data-cal-regalo.
       Se renombra ANTES de insertarlo para que la lógica antigua no lo vea. */
    tomar(nuevoInner);
    actualizarContador(nuevoInner);
    actualInner.replaceWith(nuevoInner);

    window.requestAnimationFrame(function () {
      var listaNueva = document.querySelector('#shopify-section-cart-drawer-section .cart-drawer__items');
      if (listaNueva && scrollAnterior > 0) listaNueva.scrollTop = scrollAnterior;
    });

    trabajando = false;
    intentado = '';
    programar();
  }

  function fallo(error) {
    pausaHasta = Date.now() + PAUSA_ERROR;
    trabajando = false;
    intentado = '';
    if (window.console && console.warn) {
      console.warn('[Calibre regalo] No se pudo sincronizar el regalo.', error);
    }
  }

  function tocaCarrito(mutacion) {
    var objetivo = mutacion.target;
    if (objetivo && objetivo.nodeType === 1) {
      if (objetivo.id === 'shopify-section-cart-drawer-section') return true;
      if (objetivo.closest && objetivo.closest('#shopify-section-cart-drawer-section')) return true;
    }

    for (var i = 0; i < mutacion.addedNodes.length; i += 1) {
      var n = mutacion.addedNodes[i];
      if (!n || n.nodeType !== 1) continue;
      if (n.id === 'shopify-section-cart-drawer-section') return true;
      if (n.matches && (n.matches(LEGACY) || n.matches(SAFE) || n.matches('.cart-drawer__inner'))) return true;
      if (n.querySelector && (n.querySelector(LEGACY) || n.querySelector(SAFE) || n.querySelector('.cart-drawer__inner'))) return true;
    }

    return false;
  }

  ['cart:update', 'cart:refresh', 'CartUpdateEvent'].forEach(function (ev) {
    document.addEventListener(ev, programar);
  });

  var drawer = raizCarrito();
  var observada = drawer ? drawer.parentElement : document.body;
  if (observada) {
    new MutationObserver(function (mutaciones) {
      var tocar = false;
      for (var i = 0; i < mutaciones.length; i += 1) {
        if (tocaCarrito(mutaciones[i])) {
          tocar = true;
          break;
        }
      }
      if (!tocar) return;
      tomar();
      programar();
    }).observe(observada, { childList: true, subtree: true });
  }

  tomar();
  programar();
})();
